import React, { useEffect, useRef } from 'react';
import { trackEvent } from '../utils/tracking';
const BACKEND_URL = 'https://mercadopago-her-backend.vercel.app';
const MP_PUBLIC_KEY = 'APP_USR-2e5e9ad0-2e5a-4077-b86b-9ae196fe76ec';
interface WalletBrickCTAProps {
  email?: string;
}
export function WalletBrickCTA({
  email = ''
}: WalletBrickCTAProps) {
  const rendered = useRef(false);
  const getCookie = (name: string) => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? decodeURIComponent(match[2]) : undefined;
  };
  const generateEventId = () => `HER-${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;
  useEffect(() => {
    if (rendered.current) return;
    rendered.current = true;
    const initBrick = async () => {
      console.log('🚀 Inicializando Wallet Brick');
      const mp = new (window as any).MercadoPago(MP_PUBLIC_KEY);
      const bricksBuilder = mp.bricks();
      await bricksBuilder.create('wallet', 'wallet_container_offer', {
        initialization: {},
        customization: {
          texts: {
            valueProp: 'smart_option'
          }
        },
        callbacks: {
          onReady: () => {
            console.log('✅ Wallet listo');
            trackEvent('wallet_ready', {
              section: 'offer'
            });
          },
          onSubmit: (formData: any) => {
            console.log('🟡 onSubmit ejecutado');
            console.log('formData recibido:', formData);
            const eventId = generateEventId();
            const fbp = getCookie('_fbp');
            const fbc = getCookie('_fbc');

            // click-cta: fire-and-forget
            fetch(`${BACKEND_URL}/api/click-cta`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                event_id: eventId,
                fbp,
                fbc,
                currency: 'ARS',
                value: 12000
              })
            }).catch(() => {});
            trackEvent('begin_checkout', {
              section: 'offer'
            }, {
              eventId
            });

            // MP espera que se resuelva la promesa con el preference_id
            return new Promise<string>((resolve, reject) => {
              console.log('📡 Creando preferencia...');
              fetch(`${BACKEND_URL}/api/create-preference`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  title: 'Protocolo H.E.R. — Acceso Completo',
                  quantity: 1,
                  unit_price: 12000,
                  external_reference: eventId,
                  event_id: eventId,
                  fbp,
                  fbc,
                  // Email capturado en el paso anterior del checkout
                  email: email || undefined
                })
              }).then(res => {
                console.log('Status:', res.status);
                console.log('OK:', res.ok);
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
              }).then(data => {
                console.log('📦 Response:', data);
                console.log('🔑 preference_id:', data.preference_id);
                if (!data.preference_id) throw new Error('No preference_id');

                // InitiateCheckout: mismo timing que antes (post preference_id)
                if (typeof window !== 'undefined' && (window as any).fbq) {
                  ;
                  (window as any).fbq('track', 'InitiateCheckout', {}, {
                    eventID: eventId
                  });
                }
                console.log('✅ Resolviendo:', data.preference_id);
                resolve(data.preference_id);
              }).catch(err => {
                console.error('❌ Error en fetch:', err);
                reject();
              });
            });
          },
          onError: (error: any) => {
            console.error('🚨 Wallet Error:', error);
            console.error('Code:', error?.cause?.error);
            console.error('Detail:', JSON.stringify(error));
            trackEvent('wallet_error', {
              section: 'offer',
              message: error?.message ?? String(error),
              code: error?.code
            });
          }
        }
      });
    };
    if ((window as any).MercadoPago) {
      initBrick();
      return;
    }
    const existing = document.querySelector('script[src="https://sdk.mercadopago.com/js/v2"]') as HTMLScriptElement | null;
    if (existing) {
      existing.addEventListener('load', initBrick, {
        once: true
      });
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://sdk.mercadopago.com/js/v2';
    script.async = true;
    script.onload = initBrick;
    document.head.appendChild(script);
  }, []);
  return <div id="wallet_container_offer" className="w-full" data-id="element-420" data-mp="31hmprxt7f02l" />;
}